/**
 * STACKED_GROUPED_BAR_CHART_SCHEMA: a JSON object representing a common schema for the mobile charts
 * which make up the scenario analysis section.
 */
export const STACKED_GROUPED_BAR_CHART_CONFIG = {
	chart: {
		alignTicks: true,
		spacing: 0,
		marginTop: 0,
		spacingBottom: 0,
		backgroundColor: null,
		style: {
			fontFamily: '12px "FortBook", Arial, sans-serif',
			color: '#4A4A4A'
		},
		type: 'bar',
		height: 135
	},
	plotOptions: {
		series: { stacking: 'normal' },
		bar: {
			pointWidth: '25',
			groupPadding: 0.9,
			pointPadding: 0
		}
	},
	xAxis: {
		labels: {
			enabled: false
		},
		visible: false,
		opposite: false
	},
	yAxis: {
		alignTicks: true,
		title: {
			text: null
		},
		labels: {
			enabled: false
		},
		opposite: false,
		min: 0,
		max: 0
	},
	colors: null,
	title: {
		text: null
	},
	extensibleData: null
};
